// Mutable store for the dev JWT.
//
// The dev token is seeded from `VITE_DEV_JWT` (baked at vite-build time)
// but can be replaced at runtime by the API client's 401 auto-refresh
// path. Keeping the token in zustand lets `getToken()` in the
// AuthProvider always read the current value, and lets any component
// see refreshes immediately.
//
// Not persisted to localStorage — the backend will mint a fresh one on
// 401 anyway, and persisting would risk shipping a stale token to a
// machine with a rotated DEV_JWT_SECRET.

import { create } from 'zustand';
import { env } from '../env';

interface DevTokenState {
  token: string | null;
  setToken: (t: string) => void;
}

export const useDevTokenStore = create<DevTokenState>((set) => ({
  token: env.DEV_JWT ?? null,
  setToken: (token) => set({ token }),
}));
